module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/Q5ljlJ/tc-custom/9781418557720.jpg?1708485322636",
      "alt": "This image is the cover for the book Checklist for Life: The Ultimate Handbook"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Checklist for Life: The Ultimate Handbook\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_c('i', [_vm._v("Checklist for Life")]), _vm._v(" is the ultimate handbook for living a successful, joy-filled life. In addition to a brief narrative, each chapter of this interactive handbook contains:")]), _vm._v("An \"I Will\" checklist of heart and attitude reinforcementsA \"Things to Do\" checklist of action pointsA \"Things to Remember\" section of Scripture verses and applicable quotes from famous and not-so-famous people."), _c('p', [_vm._v("Topics addressed include everyday miracles, prayer, purpose, and relationships.")]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      GRQ Ink, Inc\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Thomas Nelson\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0